import React, {ReactNode} from "react";
import Btn from "./Btn";
import P from "../lib/P";
import Octicons from '@expo/vector-icons/Octicons';
import MainStyle from "../../MainStyle";
import Fontisto from "@expo/vector-icons/Fontisto";

type Props = { selected?: boolean, disabled?: boolean, onPress?: () => void, children: ReactNode, testID?: string };

const AmountSelect = (props: Props) => {
  const {selected, disabled, children, testID} = props;

  return (
    <Btn h={56} bg={selected ? '#193B99' : '#252526'} borderBottomWidth={1} onPress={props.onPress} disabled={disabled}
         borderColor={selected ? '#193B99' : '#494A4C'} opacity={disabled ? 0.5 : 1} position="relative"
         justifyContent="center" testID={testID}>
      <P fontFamily="DavisSans-Medium" fs={18} ta="center">{children}</P>

      {selected ? (
        <Octicons name="check-circle-fill" size={24} color="white" style={[MainStyle.absolute, MainStyle.r_10]}/>
      ) : disabled ? (
        <Fontisto name="locked" size={14} color="white" style={[MainStyle.absolute, MainStyle.r_20]}/>
      ) : null}
    </Btn>
  );
};

export default AmountSelect;
